import React, { memo, ReactNode } from 'react'
import { createStyles, createTheme, makeStyles } from 'transfix-ui/core'
import { calcRem } from 'transfix-ui/theme/typography'

const useDetailItemStyles = makeStyles(() => {
  const theme = createTheme()
  return createStyles({
    root: {
      fontWeight: 400,
      fontSize: calcRem(14),
      letterSpacing: calcRem(0.25),
      lineHeight: calcRem(19),
      fontStyle: 'normal',

      [theme.breakpoints.up('md')]: {
        fontWeight: 600,
        fontSize: calcRem(12),
        lineHeight: calcRem(16),
        letterSpacing: calcRem(0.2),
      },
    },
  })
})

interface IDetailCaptionProps {
  children: ReactNode
}

const DetailCaption = memo<IDetailCaptionProps>(({ children }) => {
  const classes = useDetailItemStyles()
  return <div className={classes.root}>{children}</div>
})

export default DetailCaption
